module.exports = ["machin_learn","free_speech","onlin_platform","gender_discrimin","social_media","hate_speech","augment_realiti","digit_transform","alway_connect","smart_home","internet_freedom","tech_giant","extremist_content","social_secur","person_data","gig_economi","fake_comment","net_neutral","tech_worker","renew_energi","digit_currenc","edg_comput","quantum_comput","privaci_rule","climat_chang","selfdriv_technolog","mix_realiti","cyberattack","autom","robot","blockchain","ai","algorithm","cryptocurr","5g","gdpr"]


//////////////////
// WEBPACK FOOTER
// ./src/assets/words_news.json
// module id = wkuv
// module chunks = 1